import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
import { BreadCrumb } from '@app/interfaces';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {
  @Input() crumbPaths: BreadCrumb[];

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  navigate(crumb: BreadCrumb) {
    this.router.navigate([crumb.path])
  }
}
